import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import { ContentCard } from 'components/Card/ContentCard';
import { NotFoundErrorScreen } from 'components/screens';
import { getTrans } from 'modules/i18n';
import { FeatureFlag, useFeatureToggle } from 'modules/unleash';
import { useWeekDetails } from 'modules/week-details';
import { useShift } from '../hooks';
import { hasWorkLocationContent } from '../utils';
import { BreaksCommentView } from './BreaksCommentView';
import { FloatingButtons } from './FloatingButtons';
import { GeolocationStatusCard } from './GeolocationStatusCard';
import { LocationCommentView } from './LocationCommentView';
import { ShiftDetailsSkeleton } from './ShiftDetailsSkeleton';
import { ShiftTimeline } from './ShiftTimeline';
import { Summary } from './Summary';
import { WorkLocationView } from './WorkLocationView';

export const ShiftDetails = () => {
  const { shift, isError, isLoading } = useShift();
  const { weekId } = useParams();
  const { weekDetails, isLoading: isWeekDetailsLoading } = useWeekDetails();

  const { isEnabled: isGeolocationEnabled } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_GEOLOCATION_ENABLED
  );

  const { isEnabled: isLocationSelectionEnabled } = useFeatureToggle(
    FeatureFlag.PRO_TALENT_IS_LOCATION_SELECTION_ENABLED
  );

  if (isLoading || isWeekDetailsLoading) {
    return <ShiftDetailsSkeleton />;
  }

  if (isError) {
    return (
      <NotFoundErrorScreen
        title={getTrans('shiftDetailsPage.notFoundScreen.title')}
        description1={getTrans('shiftDetailsPage.notFoundScreen.description1')}
        description2={getTrans('shiftDetailsPage.notFoundScreen.description2')}
      />
    );
  }

  if (!shift || !weekId || !weekDetails) return null;

  const { assignments } = weekDetails;
  const assignment = assignments[weekId];

  if (!assignment) return null;

  const { isGeofenceEnabled } = assignment;

  return (
    <Box sx={{ pb: 10 }}>
      <ContentCard title={getTrans('shiftDetailsPage.summary.title')}>
        <Summary />
      </ContentCard>
      {isLocationSelectionEnabled && hasWorkLocationContent(shift.location) && (
        <ContentCard title={getTrans('shiftDetailsPage.location.title')}>
          <WorkLocationView location={shift.location} />
        </ContentCard>
      )}
      {isGeolocationEnabled &&
        isGeofenceEnabled &&
        shift?.isLocationAvailable !== undefined && (
          <ContentCard title={getTrans('shiftDetailsPage.workZone.title')}>
            <GeolocationStatusCard />
            <LocationCommentView />
          </ContentCard>
        )}
      <ContentCard title={getTrans('shiftDetailsPage.details.title')}>
        <ShiftTimeline />
        <BreaksCommentView />
      </ContentCard>
      <FloatingButtons />
    </Box>
  );
};
